import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import CheckBox from 'components/CheckBox';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../../../../reducers';
import PhaseType from 'types/phase';

class CustomerPostWalkthrough extends Resetter(Validator(React.Component)) {
  state = {
    customerCarpetSeamAndExcess: this.props.customerCarpetSeamAndExcess || false,
    customerHardSurfaceTransition: this.props.customerHardSurfaceTransition || false,
    customerHardSurfaceMolding: this.props.customerHardSurfaceMolding || false,
    customerHardSurfaceMaterial: this.props.customerHardSurfaceMaterial || false,
    customerHardSurfaceFloorHeight: this.props.customerHardSurfaceFloorHeight || false,
    customerHardSurfaceDoorCuts: this.props.customerHardSurfaceDoorCuts || false,
    customerHardSurfaceWaste: this.props.customerHardSurfaceWaste || false,
    errors: {},
  };

  customerPostWalkthroughRef = React.createRef();

  componentDidMount = () => this.customerPostWalkthroughRef.current.scrollIntoView(false);

  handleSubmit = () => {
    const { customerCarpetSeamAndExcess, customerHardSurfaceTransition,
       customerHardSurfaceMolding, customerHardSurfaceMaterial,
      customerHardSurfaceFloorHeight, customerHardSurfaceDoorCuts,
      customerHardSurfaceWaste } = this.state;
    this.props.updateFormData({
      customerCarpetSeamAndExcess,
      customerHardSurfaceTransition,
      customerHardSurfaceMolding,
      customerHardSurfaceMaterial,
      customerHardSurfaceFloorHeight,
      customerHardSurfaceDoorCuts,
      customerHardSurfaceWaste,
      tab: 4,
    });
  }

  handlePrevious = () => {
    const tab = this.props.surfaceType === 'hard_surface' ? 1 : 2;
    const { customerCarpetSeamAndExcess, customerHardSurfaceTransition,
      customerHardSurfaceMolding, customerHardSurfaceMaterial,
      customerHardSurfaceFloorHeight, customerHardSurfaceDoorCuts,
      customerHardSurfaceWaste } = this.state;
    this.props.updateFormData({
      customerCarpetSeamAndExcess,
      customerHardSurfaceTransition,
      customerHardSurfaceMolding,
      customerHardSurfaceMaterial,
      customerHardSurfaceFloorHeight,
      customerHardSurfaceDoorCuts,
      customerHardSurfaceWaste,
      tab,
    });
  }

  handleCustomerCarpetSeamAndExcess = () =>
    this.setState({ customerCarpetSeamAndExcess: !this.state.customerCarpetSeamAndExcess });


  handleCustomerHardSurfaceTransition = () =>
    this.setState({ customerHardSurfaceTransition: !this.state.customerHardSurfaceTransition });


  handleCustomerHardSurfaceMolding = () =>
    this.setState({ customerHardSurfaceMolding: !this.state.customerHardSurfaceMolding });


  handleCustomerHardSurfaceMaterial = () =>
    this.setState({ customerHardSurfaceMaterial: !this.state.customerHardSurfaceMaterial });


  handleCustomerHardSurfaceFloorHeight = () =>
    this.setState({ customerHardSurfaceFloorHeight: !this.state.customerHardSurfaceFloorHeight });


  handleCustomerHardSurfaceDoorCuts = () =>
    this.setState({ customerHardSurfaceDoorCuts: !this.state.customerHardSurfaceDoorCuts });


  handleCustomerHardSurfaceWaste = () =>
    this.setState({ customerHardSurfaceWaste: !this.state.customerHardSurfaceWaste });


  render = () => {
    const { isSpanish } = this.props;
    const {
      customerCarpetSeamAndExcess,
      customerHardSurfaceTransition,
      customerHardSurfaceMolding,
      customerHardSurfaceMaterial,
      customerHardSurfaceFloorHeight,
      customerHardSurfaceDoorCuts,
      customerHardSurfaceWaste,
      errors,
    } = this.state;

    return (<div ref={this.customerPostWalkthroughRef}>
      <h6>
        {isSpanish ? 'Lista de Verificación del Cliente' : 'Customer Checklist'}
      </h6>
      {this.props.surfaceType.toLowerCase() === 'carpet' ? (<span>
        <CheckBox
          required
          text={isSpanish
            ? 'Apruebo la nueva ubicación de la costura y el exceso de alfombra'
            : 'I approve new seam location and excess carpet (if applicable)'
          }
          errors={errors.customerCarpetSeamAndExcess}
          onChange={this.handleCustomerCarpetSeamAndExcess}
          checked={customerCarpetSeamAndExcess}
        />
      </span>) : (<span>
        <CheckBox
          required
          text={isSpanish
            ? 'El color y el estilo de transición son para mi satisfacción'
            : 'Transition color and style is to my satisfaction'
          }
          errors={errors.customerHardSurfaceTransition}
          onChange={this.handleCustomerHardSurfaceTransition}
          checked={customerHardSurfaceTransition}
        />
        <CheckBox
          required
          text={isSpanish
            ? 'Moldear color y estilo es para mi satisfacción'
            : 'Molding color and style is to my satisfaction'
          }
          errors={errors.customerHardSurfaceMolding}
          onChange={this.handleCustomerHardSurfaceMolding}
          checked={customerHardSurfaceMolding}
        />
        <CheckBox
          required
          text={isSpanish
            ? 'El color y el estilo del material son para mi satisfacción'
            : 'Material color and style is to my satisfaction'
          }
          errors={errors.customerHardSurfaceMaterial}
          onChange={this.handleCustomerHardSurfaceMaterial}
          checked={customerHardSurfaceMaterial}
        />
        <CheckBox
          required
          text={isSpanish
            ? 'La altura del piso es para mi satisfacción'
            : 'Floor height is to my satisfaction'
          }
          errors={errors.customerHardSurfaceFloorHeight}
          onChange={this.handleCustomerHardSurfaceFloorHeight}
          checked={customerHardSurfaceFloorHeight}
        />
        <CheckBox
          required
          text={isSpanish
            ? 'Los cortes de puerta son para mi satisfacción'
            : 'Door cuts are to my satisfaction'
          }
          errors={errors.customerHardSurfaceDoorCuts}
          onChange={this.handleCustomerHardSurfaceDoorCuts}
          checked={customerHardSurfaceDoorCuts}
        />
        <CheckBox
          required
          text={isSpanish
            ? 'Se ofreció desperdicio'
            : 'Waste was offered'
          }
          errors={errors.customerHardSurfaceWaste}
          onChange={this.handleCustomerHardSurfaceWaste}
          checked={customerHardSurfaceWaste}
        />
      </span>)}
      <Button
        label={isSpanish ? 'Próximo' : 'Next'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handleSubmit}
      />
      <Button
        label={isSpanish ? 'Anterior' : 'Previous'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handlePrevious}
      />
    </div>);
  }
}

CustomerPostWalkthrough.propTypes = {
  isSpanish: PropTypes.bool,
  phase: PhaseType.isRequired,
  surfaceType: PropTypes.string,
  customerCarpetSeamAndExcess: PropTypes.bool,
  customerHardSurfaceTransition: PropTypes.bool,
  customerHardSurfaceMolding: PropTypes.bool,
  customerHardSurfaceMaterial: PropTypes.bool,
  customerHardSurfaceFloorHeight: PropTypes.bool,
  customerHardSurfaceDoorCuts: PropTypes.bool,
  customerHardSurfaceWaste: PropTypes.bool,
  errors: PropTypes.shape({
    customerCarpetSeamAndExcess: PropTypes.arrayOf(PropTypes.string),
    customerHardSurfaceTransition: PropTypes.arrayOf(PropTypes.string),
    customerHardSurfaceMolding: PropTypes.arrayOf(PropTypes.string),
    customerHardSurfaceMaterial: PropTypes.arrayOf(PropTypes.string),
    customerHardSurfaceFloorHeight: PropTypes.arrayOf(PropTypes.string),
    customerHardSurfaceDoorCuts: PropTypes.arrayOf(PropTypes.string),
    customerHardSurfaceWaste: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(CustomerPostWalkthrough);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/post/customerPostWalkthrough.jsx